module.exports = __webpack_public_path__ + "static/media/EasyWords_ios_1_preview.e5530f2b.jpg";